export default "__VITE_ASSET__8fa4a700__"